import type { IxcTrfV1TrfSessionKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const TRF_SESSION_BASE_PATH = getResolvedPath('/clearing/operations/trade/trf-session');

export const getTrfSessionPath: EntityPathBuilder<IxcTrfV1TrfSessionKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return TRF_SESSION_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.sessionId) {
        return undefined;
      }

      return getResolvedPath(`${TRF_SESSION_BASE_PATH}/$sessionId`, context.keys);
    }
  }
};

export function getTrfSessionDetailPath(sessionId: string | undefined) {
  if (!sessionId) {
    return undefined;
  }

  return getTrfSessionPath({ kind: 'detail', keys: { sessionId } });
}
